import './Loader.css';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  tone?: 'brand' | 'light';
  /** When set, renders the loader centered above this text with consistent spacing. */
  label?: string;
  className?: string;
  style?: React.CSSProperties;
}

const SIZE_HEIGHT: Record<NonNullable<LoaderProps['size']>, number> = {
  sm: 16,
  md: 32,
  lg: 44,
};

export default function Loader({ size = 'md', tone = 'brand', label, className = '', style }: LoaderProps) {
  const height = SIZE_HEIGHT[size];
  const width = height * 2.2;

  const icon = (
    <span className={`me-loader me-loader--${tone}`} style={{ width, height }} role="status" aria-label="Loading">
      <svg viewBox="0 0 88 40" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="meLoaderGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="var(--me-loader-stop-1)" />
            <stop offset="100%" stopColor="var(--me-loader-stop-2)" />
          </linearGradient>
        </defs>
        <circle className="me-loader__dot me-loader__dot--1" cx="12" cy="20" r="7" fill="url(#meLoaderGradient)" />
        <circle className="me-loader__dot me-loader__dot--2" cx="34" cy="20" r="10" fill="url(#meLoaderGradient)" />
        <circle className="me-loader__dot me-loader__dot--3" cx="54" cy="20" r="10" fill="url(#meLoaderGradient)" />
        <circle className="me-loader__dot me-loader__dot--4" cx="76" cy="20" r="7" fill="url(#meLoaderGradient)" />
      </svg>
    </span>
  );

  return (
    <span
      className={`me-loader-wrap ${label ? 'me-loader-wrap--block' : 'me-loader-wrap--inline'} ${className}`.trim()}
      style={style}
    >
      {icon}
      {label && <span className="me-loader-wrap__label">{label}</span>}
    </span>
  );
}
